import * as actionTypes from "../constants/ActionTypes";

export const setLoading = (payload) => ({ type: actionTypes.SET_LOADING, payload });

export const setOverlay = (payload) => ({ type: actionTypes.SET_OVERLAY, payload });

export const openSnackbar = (type, message, duration) => ({ type: actionTypes.OPEN_SNACK_BAR, payload: { type, message, duration} });

export const closeSnackbar = () => ({ type: actionTypes.CLOSE_SNACK_BAR });

export const setSearchableProducts = (payload) => ({ type: actionTypes.SET_SEARCHABLE_PRODUCTS, payload });
export const setGlobalVariables = (payload) => ({ type: actionTypes.SET_GLOBAL_VARIABLES, payload });

export const nextStep = () => ({ type: actionTypes.NEXT_STEP });

export const prevStep = () => ({ type: actionTypes.PREV_STEP });

export const setStep = (payload) => ({ type: actionTypes.SET_STEP, payload });

export const togglePrimaryColor = () => ({ type: actionTypes.TOGGLE_PRIMARY_COLOR });

export const updateProductDetail = (payload) => ({
  type: actionTypes.UPDATE_PRODUCT_DETAIL,
  payload,
})

export const updateFormError = (payload) => ({ type: actionTypes.UPDATE_FORM_ERROR, payload });
export const setFormErrors = (payload) => ({ type: actionTypes.SET_FORM_ERRORS, payload });

export const setDiscount = (payload) => ({
  type: actionTypes.SET_DISCOUNT,
  payload,
});

export const removeDiscount = () => ({ type: actionTypes.REMOVE_DISCOUNT });

export const setPaymentType = (payload) => ({ type: actionTypes.SET_PAYMENT_TYPE, payload });
